import api from '../../utils/helpers/api'

type LoginType = {
  data: any
  meta: object
}

export async function login(data: object) {
  return (await api.post('/auth/login', data)) as Promise<LoginType>
}

export async function requestActivation(data: object) {
  return (await api.post('/auth/request-activation', data)) as Promise<LoginType>
}

export async function forgotPassword(data: object) {
  return (await api.post('/auth/forgot-password', data)) as Promise<LoginType>
}

export async function confirmForgotPassword(code: any, data: object) {
  return (await api.post(`/auth/confirm-email/${code}`, data)) as Promise<LoginType>
}

export async function moduleAccess() {
  return (await api.get('profile/module-object-list')) as Promise<LoginType>
}